var FilesDialogView = require('filesdialogview');
var PastebinView = require('pastebinview');

var PastebinsDialogView = FilesDialogView.extend({
    el: '#pastebinsOverlayContents',
    wrapper: $('#pastebinsContainer'),
    list: $('#pastebinList'),
    urlRoot: 'pastebins',
    collectionKey: 'pastebins',
    modelView: PastebinView,
    removeModel: function (model) {
        var view = this.modelViews[model.id];
        view.clearTimeago();
        FilesDialogView.prototype.removeModel.apply(this, arguments);
    },
    renderView: function (view) {
        return view.render({
            header: true,
            date: true,
            linkDate: true
        });
    }
});


module.exports = PastebinsDialogView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/pastebinsdialogview.js
// module id = 3BDD
// module chunks = 1